import { FC } from "react";
import { CommandButtonGroup } from "@remirror/react-ui";

import {
  ToggleBulletListButton,
  ToggleOrderedListButton,
  ToggleTaskListButton,
} from "./ListButtons";

export interface ListButtonGroupProps {
  onBlur: () => void;
}

export const ListButtonGroup: FC<ListButtonGroupProps> = ({ onBlur }) => (
  <CommandButtonGroup>
    <ToggleBulletListButton onBlur={onBlur} />
    <ToggleOrderedListButton onBlur={onBlur} />
    <ToggleTaskListButton onBlur={onBlur} />
  </CommandButtonGroup>
);
